import FondationsServiceModel from '@/models/FondationsServiceModel';
import EntityModel            from '@/models/services/fondations/EntityModel';
import doc                    from '@widesk-core/decorators/doc';
import { Dayjs }              from 'dayjs';

export default class AddressModel extends FondationsServiceModel {
	private declare _tsFilters: {
		'entity': id;
		'dateEnd[after]': string;
		'dateEnd[before]': string;
		'dateEnd[strictly_after]': string;
		'dateEnd[strictly_before]': string;
	};

	static get path(): string {
		return '/addresses/{?id}';
	}

	// L'API n'autorise pas PUT et exige application/merge-patch+json pour les mises à jour
	public save(options: ConnectorSaveOptions = {}) {
		return super.save(this.id ? { method: 'patch', headers: { 'Content-Type': 'application/merge-patch+json' }, ...options } as ConnectorSaveOptions : options);
	}

	@doc.model(EntityModel) declare entity: EntityModel;

	@doc.string declare addressLine: string;
	@doc.string declare addressLineBis: string;
	@doc.string declare zipcode: string;
	@doc.string declare city: string;
	@doc.string declare country: string;
	@doc.date  declare createdAt: Dayjs;
	@doc.date  declare updatedAt: Dayjs;
}
